import React from 'react'

const ValidURL = (string) => {
  if (string.string != null) {
    if (string.string) {
        const stringArray = string.string.split(" ");
        const regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      return (
        stringArray.map(index => {
            return index.match(regex) ? <a href={index} target="_blank">{index} {" "}</a> : <>{index} {""}</>
        })
      )
    } else {
      return <></>
    }
  } else {
    if (string) {
        const stringArray = string.split(" ");
        const regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      return (
        stringArray.map(index => {
            return index.match(regex) ? <a href={index} target="_blank">{index} {" "}</a> : <>{index} {""}</>
        })
      )
    } else {
      return <></>
    }
  }
}

export default ValidURL